import ToneOfVoice from "@/models/tone-of-voice/toneOfVoice";
import { crudService, CrudServiceType } from "./crudService";
import { RestClient } from "./restClient";

export type ToneOfVoiceServiceType = CrudServiceType<ToneOfVoice>;

const toneOfVoiceService = (
  client: RestClient,
  path: string
): ToneOfVoiceServiceType => ({
  ...crudService<ToneOfVoice>(client, path),
});

export default toneOfVoiceService;
